import CampaignCenter from './campaign-center';

export default CampaignCenter;
